import { TagType } from 'types/types'

const WORDS = 'words'
const PHRASES = 'phrases'
const SENTENCE = 'sentence'

const TAG_SORT_ORDER = [WORDS, PHRASES, SENTENCE]

export function filterVisibleTags(tags: TagType[]): TagType[] {
  return tags.filter((tag) => !tag.hidden)
}

export function filterHiddenTags(tags: TagType[]): TagType[] {
  return tags.filter((tag) => tag.hidden)
}

export function sortByTagOrder(tags: TagType[]): TagType[] {
  return [...tags].sort((a, b) => TAG_SORT_ORDER.indexOf(a.name) - TAG_SORT_ORDER.indexOf(b.name))
}

export function findTagByName(tags: TagType[], name: string): TagType | undefined {
  return tags.find((tag) => tag.name === name)
}

export function phrasingFromTags(tags: TagType[]): typeof SENTENCE | typeof PHRASES | typeof WORDS | null {
  const hiddenTag = filterHiddenTags(tags).find((tag) => TAG_SORT_ORDER.includes(tag.name))
  return (hiddenTag?.name as typeof SENTENCE | typeof PHRASES | typeof WORDS) || null
}

export { PHRASES, SENTENCE, TAG_SORT_ORDER, WORDS }
